<template>
  <div class="login">
    <div class="loginPicBox">
      <img src="@/assets/login.png" class="loginPic" />
    </div>
    <div class="loginBox">
      <div class="loginContainer" style="opacity: 1">
        <div class="loginContent">
          <div class="topRow">
            <div>
              <img src="../assets/logo2.png" class="logotitle" />
            </div>
            <div>
              <img src="../assets/title.png" style="" class="titlename" />
            </div>
          </div>
          <a-row>
            <a-col>
              <div class="loginfrom">
                <a-row class="inputbar" type="flex" align="middle">
                  <a-col
                    class="inputtext"
                    :xs="{ span: 5, offset: 0 }"
                    :md="{ span: 5, offset: 3 }"
                  >
                    <span class="formtitle">身份：</span>
                  </a-col>
                  <a-col
                    class="inputBox"
                    :xs="{ span: 19, offset: 0 }"
                    :md="{ span: 12, offset: 0 }"
                    @click.stop
                  >
                    <a-select
                      class="departselect"
                      v-model="chooseClient"
                      style="width: 100%"
                    >
                      <!-- @change="clientChange" -->
                      <!-- chooseClient  t教师端 a或不传 默认管理端 -->
                      <a-select-option class="depart" key="t" value="t">
                        项目组织方
                      </a-select-option>
                      <a-select-option class="depart" key="a">
                        技术支持服务端
                      </a-select-option>
                      <a-select-option class="depart" key="s">
                        受训人员
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row
                  class="inputbar"
                  type="flex"
                  align="middle"
                  v-show="chooseClient != 's'"
                >
                  <a-col
                    class="inputtext"
                    :xs="{ span: 5, offset: 0 }"
                    :md="{ span: 5, offset: 3 }"
                  >
                    <span class="formtitle">账号：</span>
                  </a-col>
                  <a-col
                    class="inputBox"
                    :xs="{ span: 19, offset: 0 }"
                    :md="{ span: 12, offset: 0 }"
                  >
                    <a-input
                      @blur="blur"
                      v-model="username"
                      placeholder="请输入用户名"
                    ></a-input>
                  </a-col>
                </a-row>
                <a-row
                  class="inputbar"
                  type="flex"
                  align="middle"
                  v-show="chooseClient != 's'"
                >
                  <a-col
                    class="inputtext"
                    :xs="{ span: 5, offset: 0 }"
                    :md="{ span: 5, offset: 3 }"
                  >
                    <span class="formtitle">密码：</span>
                  </a-col>
                  <a-col
                    class="inputBox"
                    :xs="{ span: 19, offset: 0 }"
                    :md="{ span: 12, offset: 0 }"
                  >
                    <a-input
                      placeholder="请输入密码"
                      v-model="userpwd"
                      type="password"
                      show-password
                      @blur="blur"
                    ></a-input>
                  </a-col>
                </a-row>
                <a-row
                  class="inputbar"
                  type="flex"
                  align="middle"
                  v-show="chooseClient != 's'"
                >
                  <a-col
                    class="inputtext"
                    :xs="{ span: 5, offset: 0 }"
                    :md="{ span: 5, offset: 3 }"
                  >
                    <span class="formtitle yzm">验证码：</span>
                  </a-col>
                  <a-col
                    class="yzminputBox"
                    :xs="{ span: 12, offset: 0 }"
                    :md="{ span: 8, offset: 0 }"
                  >
                    <!-- v-decorator="['inputCode', validatorRules.inputCode]" -->
                    <a-input
                      size="large"
                      type="text"
                      @change="inputCodeChange"
                      placeholder="请输入验证码"
                      style="margin-right: 10px"
                    >
                      <!-- <a-icon
                    slot="prefix"
                    type="smile"
                    :style="{ color: 'rgba(0,0,0,.25)' }"
                  /> -->
                    </a-input>
                  </a-col>
                  <a-col
                    :xs="{ span: 6, offset: 0 }"
                    :md="{ span: 4, offset: 0 }"
                    class="codeCol"
                    style="text-align: right; margin-left: 5px"
                  >
                    <img
                      v-if="requestCodeSuccess"
                      :src="randCodeImage"
                      @click="handleChangeCheckCode"
                    />
                    <img
                      v-else
                      src="./../assets/checkcode.png"
                      @click="handleChangeCheckCode"
                    />
                  </a-col>
                </a-row>
                <a-row
                  class="forgetBox"
                  type="flex"
                  align="middle"
                  justify="center"
                  v-show="chooseClient != 's'"
                >
                  <a-col :span="24">
                    <span class="forget"
                      >如果忘记密码，请联系热线电话：4000969899</span
                    >
                  </a-col>
                </a-row>
                <!-- 受训人员登录 -->
                <a-row
                  class="inputbar"
                  type="flex"
                  align="middle"
                  v-show="chooseClient == 's'"
                >
                  <a-col
                    class="inputtext"
                    :xs="{ span: 5, offset: 0 }"
                    :md="{ span: 5, offset: 3 }"
                  >
                    <span class="formtitle">编码：</span>
                  </a-col>
                  <a-col
                    class="inputBox"
                    :xs="{ span: 19, offset: 0 }"
                    :md="{ span: 12, offset: 0 }"
                  >
                    <a-input
                      @blur="blur"
                      v-model="digCode"
                      placeholder="请输入您的编码"
                    ></a-input>
                  </a-col>
                </a-row>
                <a-row
                  type="flex"
                  align="middle"
                  v-show="chooseClient == 's'"
                  class="saoma"
                >
                  <a-col
                    class="smCol"
                    :xs="{ span: 24, offset: 0 }"
                    @click="handleSaoMa"
                  >
                    <img src="../assets/saoma.png" />
                    <span>扫 码</span>
                  </a-col>
                </a-row>
                <!-- 受训人员登录end -->

                <a-row
                  class="inputbar"
                  type="flex"
                  align="middle"
                  justify="center"
                >
                  <a-col :span="24">
                    <a-spin :spinning="spinning">
                      <a-button
                        @click.stop.prevent="handleLogin"
                        class="logbtn"
                        round
                        >登录</a-button
                      >
                    </a-spin>
                  </a-col>
                  <div class="logo-text">提升应急素养 护航生命安全</div>
                </a-row>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import infoAction from "@/utils";
import { isMobile, isWX } from "@/utils";
import { postAction, getAction } from "../api/manage";
import {
  ACCESS_TOKEN,
  USER_NAME,
  USER_INFO,
  UI_CACHE_DB_DICT_DATA,
} from "@/store/mutation-types";
import Vue from "vue";

const APPID = window.network["appid"];

export default {
  name: "Login2",
  data() {
    return {
      username: "",
      userpwd: "",
      spinning: false,
      codeshow: false,
      activeCode: "",
      activeCodelist: [],
      url: {
        login: "/teacher/yhaTeacher/list",
        getcodelist: "/qrcode/yhaDigitalCode/activeCode",
        trainarrange: "/repcomposer/repComposer/report",
      },
      verifiedCode: "",
      inputCodeContent: "",
      currentUsername: "",
      currdatetime: "",
      randCodeImage: "",
      requestCodeSuccess: false,
      chooseClient: "s",
      digCode: "",
      wxReady: false,
    };
  },
  created() {
    this.currdatetime = new Date().getTime();
    Vue.ls.remove(ACCESS_TOKEN);
    this.handleChangeCheckCode();
    this.wxinit();
  },
  methods: {
    wxinit() {
      let that = this;
      if (!isWX()) {
        return;
      }
      getAction(`/wx/jsapi/${APPID}/getJsapiTicket`, {
        url: document.location.href,
      }).then((res) => {
        debugger;
        if (res.success) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: APPID, // 必填，公众号的唯一标识
            timestamp: res.result.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.result.nonceStr, // 必填，生成签名的随机串
            signature: res.result.signature, // 必填，签名
            jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
          });
          wx.ready(function (e) {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            that.wxReady = true;
            console.log("-- wxconfig 成功", e);
          });
          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log("-- wxconfig信息验证失败会执行error函数", res);
          });
        }
      });
    },
    handleSaoMa() {
      if (!isWX()) {
        this.$message.warning("请在微信中使用");
        return;
      }
      if (!this.wxReady) {
        console.log("微信没准备好");
        return;
      }
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        // scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          debugger;
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        },
      });
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime();
      getAction(`/sys/randomImage/${this.currdatetime}`)
        .then((res) => {
          if (res.success) {
            this.randCodeImage = res.result;
            this.requestCodeSuccess = true;
          } else {
            this.$message.error(res.message);
            this.requestCodeSuccess = false;
          }
        })
        .catch(() => {
          this.requestCodeSuccess = false;
        });
    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value;
    },
    stuLogin() {
      debugger
      // digCode
      let that = this;
      getAction("/student/yhaStudent/qStuByDigital", {
        digitalCode: this.digCode.trim(),
      }).then((res) => {
        debugger;
        if (res.code == 200) {
          console.log(res)
          localStorage.setItem("digitalCode", that.digCode);
          that.$message.success("登录成功");
          //   数字码登录跳转：
          if (res.result) {
            localStorage.setItem(
              "stuInfo",
              JSON.stringify(res.result.stu)
            );
            localStorage.setItem(
              "stuInfo1",
              JSON.stringify(res.result.DigitalCode)
            );
            debugger
            // 受训人员数字码其他信息
            localStorage.setItem(
              "actBatchCode",
              res.result.DigitalCode.actBatchCode
            );
          }

          const REDIRECT_URI = encodeURIComponent(
            `${window.network["studentMainURL"]}?digitalCode=${this.value}`
          );
          const SCOPE = "snsapi_userinfo";
          let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=STATE`;

          if (!isWX()) {
            window.location.href =
              window.network["studentBasePath"] +
              "/mygradestwo?digitalCode=" +
              this.digCode;
          } else {
            window.location.href = url;
          }
        } else if (res.code == 600) {
          that.$message.info("此数字码不存在，请修改。");
        } else if (res.code == 700) {
          localStorage.setItem("digitalCode", this.digCode);
          localStorage.setItem(
              "actBatchCode",
              res.result.DigitalCode.actBatchCode
            );
          // 数字码未绑定信息跳转：
          // this.$router.push("/information");
          window.location.href =
            window.network["studentBasePath"] + "/information";
          that.$message.info(res.message + "请添加信息");
        }
      });
    },
    handleLogin() {
      localStorage.clear();
      localStorage.setItem('chooseClient', this.chooseClient)
      //  跳转受训人员端
      console.log('chooseClient'+this.chooseClient)
      if ("s" == this.chooseClient) {
        console.log('bbbbbbbbbb')
        this.stuLogin();
        return;
      }
      var that = this;
      if (!this.username) {
        this.$message.info("请输入用户名");
        return;
      }
      if (!this.userpwd) {
        this.$message.info("请输入密码");
        return;
      }
      this.spinning = !this.spinning;
      postAction("/sys/login", {
        username: that.username,
        password: that.userpwd,
        captcha: that.inputCodeContent,
        checkKey: that.currdatetime,
        chooseClient: that.chooseClient,
      })
        .then((res) => {
          debugger;
          if (res.code == 200) {
            const result = res.result;
            const userInfo = result.userInfo;
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000);
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000);
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000);
            Vue.ls.set(
              UI_CACHE_DB_DICT_DATA,
              result.sysAllDictItems,
              7 * 24 * 60 * 60 * 1000
            );

            // 教师端登录
            switch (that.chooseClient) {
              case "t":
                infoAction.setinfo(
                  "universityId_dictText",
                  result.universityId_dictText
                );
                infoAction.setinfo(
                  "teacher_info",
                  JSON.stringify(result.teacher)
                );
                infoAction.setinfo(
                  "TeacherVersion",
                  result.teacher.teacherVersion
                );

                this.$message.success("登录成功");
                if (isMobile()) {
                  this.$router.push("/homepagetwo");
                } else {
                  
                  let TeacherVersion = infoAction.getinfo("TeacherVersion");
                  if (TeacherVersion == 0) {
                    this.$router.push("/homepagetwo");
                  }else if (TeacherVersion == 1) {
                    window.location = "/admin/dashboard/analysis";
                  }
                  
                }
                break;
              default:
                // 管理端
                that.jumpToAdmin(result);
                break;
            }
          } else {
            this.$message.warning(
              (res || {}).message || "请求出现错误，请稍后再试"              
            );
            this.handleChangeCheckCode()
          }
        })
        .finally(() => {
          this.spinning = !this.spinning;
        });
    },
    jumpToAdmin(result) {
      infoAction.setinfo(
          "admin_info",
          JSON.stringify(result.userInfo.realname)
        );
      if (isMobile()) {
        this.$router.push("/Adminhomepage");
      } else {
        window.location = "/admin/dashboard/analysis";
      }
    },
    blur() {
      setTimeout(function () {
        var scrollHeight = window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
.login {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: url("../assets/webbg.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;
  display: flex;
  padding-left: 10%;
}
}
@media screen and (max-width: 768px) {
.login {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: url("../assets/webbg.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;
  display: flex;
}
}
@media screen and (min-width: 768px) {
  .loginPicBox {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 768px) {
  .loginPicBox {
    display: none;
  }
}
.loginPic {
  flex: 1;
  width: 50%;
  flex-shrink: 1;
}
body {
  background: "#073865";
}
.smCol {
  margin-bottom: 4vh;
  margin-top: 1vh;
}
.smCol > img {
  width: 15%;
  height: auto;
}
.smCol > span {
  margin-top: 5px;
  display: block;
  color: white;
}
@media screen and (min-width: 768px) {
  .saoma {
    display: none;
  }
}
@media screen and (min-width: 768px) {
  .smCol {
    margin-bottom: 5vh;
    margin-left: 6%;
  }
}

.topRow {
  margin-top: 6vh;
}
.topRow div {
  position: relative;
  top: 6vh;
  display: flex;
  justify-content: center;
}
.codeCol > img {
  width: 100%;
  height: auto;
  max-height: 40px;
}

.tubiao {
  widows: 250px;
  height: 250px;
  position: absolute;
  bottom: -40%;
  left: 45%;
}
.logo {
  margin-top: 3vh;
  width: 10vw;
}
.title {
  height: 10vh;
  line-height: 10vh;
  font-size: 22px;
  font-weight: bold;
}
.logotitle {
  width: 100px;
  height: 30px;
}
.log {
  width: 100%;
  position: absolute;
  top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .loginfrom {
    margin-top: 5vh;
    box-sizing: border-box;
    padding: 0 11vw;
  }
}

@media screen and (min-width: 768px) {
  .loginBox {
    width: 50%;
    position: relative;
    left: 5%;
  }
}
@media screen and (min-width: 768px) {
  .loginContainer {
    width: 450px;
    background: rgba(243, 235, 235, 0.5);
  }
}
@media screen and (min-width: 768px) {
.loginContent {
  width: 600px;
  margin-left: -17%;
}
}
@media screen and (min-width: 768px) {
  .logo-text {
    width: 300px;
    color: #ffffff;
    font-size: 18px;
    margin-left: 14.5%;
  }
}
@media screen and (max-width: 768px) {
  .logo-text {
    width: 300px;
    color: #ffffff;
    font-size: 18px;
    margin-top: 20px;
  }
}
@media screen and (min-width: 768px) {
  .loginfrom {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15% 6%;
    position: relative;
    left: -6%;
    margin-left: 1%;
  }
}
@media screen and (min-width: 768px) {
  .inputBox {
    width: 64%;
  }
}

@media screen and (min-width: 768px) {
  .yzminputBox {
    width: 45%;
  }
}
.ant-select-selection {
  background: #b3d9fe !important;
  border: none !important;
}

.inputbar {
  /* display: flex;
  justify-content: space-between; */
  /* align-items: center; */
  height: 7vh;
  line-height: 7vh;
  margin-bottom: 20px;
}
@media screen and (max-width: 768px) {
  .inputtext {
    text-align: left;
  }
}

.inputStyle {
  width: 80%;
}
@media screen and (max-width: 768px) {
.forget {
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  margin-left: 2%;
}
}
@media screen and (min-width: 768px) {
.forgetBox {
  margin-top: 24px;
  margin-bottom: 28px;
}
}
@media screen and (min-width: 768px) {
.forget {
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  margin-left: 15%;
}
}
@media screen and (max-width: 768px) {
.logbtn {
  width: 100%;
  height: 43px;
  font-size: 20px;
  color: #328ffa;
  font-weight: bold;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}
}
@media screen and (min-width: 768px) {
  .logbtn {
    width: 83%;
    position: relative;
    left: 7.5%;
    height: 43px;
    font-size: 20px;
    color: #328ffa;
    font-weight: bold;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.formtitle {
  display: inline-block;
  font-size: 17px;
  color: #ffffff;
}
.yzm {
  margin-left: -1em;
}
@media screen and (max-width: 768px) {
  .login {
    width: 100vw;
    height: 100vh;
    background: url("../assets/loginbg.png") no-repeat;
    background-position: 30% 30%;
    position: relative;
  }
  .logotitle {
    width: 100px;
    height: 30px;
  }
  .titlename {
    width: 80%;
  }
  .logo {
    margin-top: 10vh;
    margin-left: 25vw;
    width: 50vw;
  }
  .tubiao {
    display: none;
  }
  .log {
    width: 100%;
    position: absolute;
    top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login2.vue